module.exports = __webpack_public_path__ + "img/upays-update.af5167c4.png";